import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { adminApi, fmtDate } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/StatusBadge";

const MessageCard = ({ m }) => (
  <article className="hx-msg" data-testid={`admin-message-${m.id}`}>
    <div className="hx-msg__head">
      <div>
        <div className="hx-strong" data-testid="admin-message-name">{m.name}</div>
        <a className="hx-muted" href={`mailto:${m.email}`} data-testid="admin-message-email">{m.email}</a>
        {m.phone && <span className="hx-muted" data-testid="admin-message-phone"> · {m.phone}</span>}
      </div>
      <div style={{ textAlign: "right" }}>
        <div className="hx-muted" data-testid="admin-message-date">{fmtDate(m.created_at)}</div>
        <StatusBadge status={m.email_status} testId="admin-message-email-status" />
      </div>
    </div>
    <p className="hx-msg__body" data-testid="admin-message-body">{m.message}</p>
  </article>
);

export const ContactMessagesTab = () => {
  const [messages, setMessages] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await adminApi.get("/admin/messages");
      setMessages(data);
    } catch (err) {
      if (err.response?.status !== 401) toast.error("Could not load messages");
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!messages) return <p className="hx-empty">Loading messages…</p>;
  return (
    <div data-testid="contact-messages-tab">
      <div className="hx-toolbar">
        <span className="hx-count" data-testid="admin-message-count">{messages.length} message{messages.length === 1 ? "" : "s"}</span>
        <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={load} data-testid="admin-refresh-button"><RefreshCw size={14} /> Refresh</button>
      </div>
      {messages.length === 0 ? (
        <p className="hx-empty" data-testid="admin-empty-state">No contact messages yet.</p>
      ) : (
        <div data-testid="admin-message-list">{messages.map((m) => <MessageCard key={m.id} m={m} />)}</div>
      )}
    </div>
  );
};
